import { CalendarGridCardTrigger } from '../CalendarGridCardTrigger'
import { CalendarGridItemCardContent } from '../CalendarGridItemCard'

import { getIsCalendarGridItemOpenedDirectly } from './CalendarGridItemTrigger.utils'

function CalendarGridItemTrigger({ Trigger, item, triggerProps, onClickItem }) {
  function handleClick(event) {
    onClickItem(item, event)
  }

  function renderContent({ onClose }) {
    return (
      <CalendarGridItemCardContent
        item={item}
        onClickItem={onClickItem}
        onClose={onClose}
      />
    )
  }

  return getIsCalendarGridItemOpenedDirectly({ item, onClickItem }) ? (
    <Trigger {...triggerProps} onClick={handleClick} />
  ) : (
    <CalendarGridCardTrigger
      Trigger={Trigger}
      renderContent={renderContent}
      triggerProps={triggerProps}
    />
  )
}

export default CalendarGridItemTrigger
